/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'available': {
    width: 194,
    height: 186,
    viewBox: '0 0 194 186',
    data: '<defs/><path pid="0" id="available" class="cls-1" d="M2328.36 617.714h-26.45V600h-17.64v53.143h17.64v-17.714h26.45v132.857h-158.72V635.429h17.63v-17.715h-17.63a17.68 17.68 0 0 0-17.64 17.715v132.857A17.679 17.679 0 0 0 2169.64 786h158.72a17.679 17.679 0 0 0 17.64-17.714V635.429a17.68 17.68 0 0 0-17.64-17.715zm-52.91 0h-61.72V600h-17.64v53.143h17.64v-17.714h61.72v-17.715zm-35.27 127.668l-32.69-32.834 12.47-12.524 20.22 20.308 37.86-38.023 12.47 12.524z" transform="translate(-2152 -600)"/>'
  }
})
